
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.143 34c8.837 0 16-7.163 16-16s-7.163-16-16-16c-8.836 0-16 7.163-16 16s7.164 16 16 16z","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"d":"M25.668 11.309a5.296 5.296 0 00-1.764-1.171 5.299 5.299 0 00-2.007-.39 5.296 5.296 0 00-3.751 1.54 5.3 5.3 0 00-3.75-1.54c-.693 0-1.37.13-2.008.39a5.337 5.337 0 00-1.764 1.17 5.3 5.3 0 00-1.562 3.772 5.3 5.3 0 001.562 3.772l7.311 7.311a.302.302 0 00.21.089.291.291 0 00.212-.088l7.311-7.312a5.3 5.3 0 001.562-3.772 5.3 5.3 0 00-1.562-3.771zM18.143 32.827C9.955 32.827 3.316 26.189 3.316 18H.97c0 9.484 7.689 17.173 17.173 17.173v-2.346zM32.97 18c0 8.189-6.638 14.827-14.827 14.827v2.346c9.485 0 17.173-7.689 17.173-17.173H32.97zM18.143 3.173C26.332 3.173 32.97 9.811 32.97 18h2.346c0-9.484-7.688-17.173-17.173-17.173v2.346zm0-2.346C8.66.827.97 8.516.97 18h2.346c0-8.189 6.639-14.827 14.827-14.827V.827z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"18.144","y1":"2","x2":"18.144","y2":"33.999","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FF7488"}}),_c('stop',{attrs:{"offset":".585","stop-color":"#FF6178"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF516A"}})])])])
          )
        }
      }
    